import _toConsumableArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import './index.css';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React from 'react';
import cx from 'classnames';
var styles = {
  "spacer": "spacer--MNKwp",
  "spacer-at-small": "spacer-at-small--Gx3iM",
  "spacer-at-phablet": "spacer-at-phablet--Z-RI6",
  "spacer-at-medium": "spacer-at-medium--RalpX",
  "spacer-at-large": "spacer-at-large--P5I8f",
  "spacer-at-huge": "spacer-at-huge--HeThH"
};
var spacing = {
  NONE: 'none',
  MICRO: 'micro',
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  BIG: 'big',
  HUGE: 'huge',
  SUPER: 'super',
  JUMBO: 'jumbo'
};
var _excluded = ["children", "all", "small", "phablet", "medium", "large", "huge", "dataId"];
// todo: use selector to cache results?
var getCSSVars = function getCSSVars(breakpoints) {
  return Object.entries(breakpoints).reduce(function (prevBP, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      breakpoint = _ref3[0],
      bpConfig = _ref3[1];
    return _objectSpread(_objectSpread({}, prevBP), Object.keys(bpConfig).reduce(function (prevSize, marginType) {
      var marginSize = bpConfig[marginType];
      if (marginType === 'vertical') {
        var _Object$assign;
        return Object.assign(prevSize, (_Object$assign = {}, _defineProperty(_Object$assign, "--rnbs-".concat(breakpoint, "-top"), "var(--rnb-spacing-".concat(marginSize, ", 0)")), _defineProperty(_Object$assign, "--rnbs-".concat(breakpoint, "-bottom"), "var(--rnb-spacing-".concat(marginSize, ", 0)")), _Object$assign));
      }
      if (marginType === 'horizontal') {
        var _objectSpread2;
        return Object.assign(prevSize, _objectSpread(_objectSpread({}, prevSize), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, "--rnbs-".concat(breakpoint, "-left"), "var(--rnb-spacing-".concat(marginSize, ", 0)")), _defineProperty(_objectSpread2, "--rnbs-".concat(breakpoint, "-right"), "var(--rnb-spacing-".concat(marginSize, ", 0)")), _objectSpread2)));
      }
      return Object.assign(prevSize, _defineProperty({}, "--rnbs-".concat(breakpoint, "-").concat(marginType), "var(--rnb-spacing-".concat(marginSize, ", 0)")));
    }, {}));
  }, {});
};
var Spacer = function Spacer(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$all = _ref.all,
    all = _ref$all === void 0 ? {} : _ref$all,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? {} : _ref$small,
    _ref$phablet = _ref.phablet,
    phablet = _ref$phablet === void 0 ? {} : _ref$phablet,
    _ref$medium = _ref.medium,
    medium = _ref$medium === void 0 ? {} : _ref$medium,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? {} : _ref$large,
    _ref$huge = _ref.huge,
    huge = _ref$huge === void 0 ? {} : _ref$huge,
    dataId = _ref.dataId,
    props = _objectWithoutProperties(_ref, _excluded);
  var breakpointsWithAllShorthand = {
    all: all,
    small: small,
    phablet: phablet,
    medium: medium,
    large: large,
    huge: huge
  };
  var customProperties = getCSSVars(breakpointsWithAllShorthand);
  return /*#__PURE__*/React.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
    style: customProperties,
    className: cx.apply(void 0, _toConsumableArray(Object.values(styles))),
    "data-id": dataId
  }), children);
};
Spacer.spacings = spacing;
export default Spacer;